import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'

import { Body2 } from '@ui/Typography'

import styles from './DepositFormWarningBox.module.scss'

interface DepositFormWarningBoxProps extends PropsWithChildren {
  className?: string
}

export const DepositFormWarningBox: FC<DepositFormWarningBoxProps> = (props) => {
  const { children, className } = props

  return (
    <Body2 isParagraph className={classNames(styles.warningMessage, className)}>
      {children}
    </Body2>
  )
}
